const initEditor = () => import('./init.ts').then(init => init.default());

window.onhashchange = () => {
  if (window.location.hash === '#edit') initEditor();
};

if (window.location.hash === '#edit') initEditor();
